/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
enum EAmbiente {
  PRODUCAO = 1,
  HOMOLOGACAO = 2,
}

export default EAmbiente;
